<%= form_with(model: category, class: "contents") do |form| %>
  <% if category.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-lg mt-3">
      <h2><%= pluralize(category.errors.count, "error") %> prohibited this category from being saved:</h2>

      <ul>
        <% category.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

<div data-controller="info-box">
<div class="info-button">&#x24D8;</div>
<ul class="info-box">
<li>Each dance can be in only one Closed, Open, and Solo category.  Adding a dance to this category will replace any prior association that dance might have had with any other category.</li>
<% if category.id %>
<li class="text-red-600">Removing a category will remove it from the agenda and make all associated dances
<span class="font-bold">unassociated with any category</span>.  Doing so will <span class="font-bold">not</span> delete any heats or scores that have been entered for that dance.</li>
<% end %>
</ul>
</div>

  <%= form.hidden_field :order %>

  <div class="my-5">
    <%= form.label :name %>
    <%= form.text_field :name, required: true,
      class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.label :day %>
    <%= form.text_field :day, placeholder: 'Saturday',
      class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full placeholder-indigo-300" %>
  </div>

  <div class="my-5">
    <%= form.label :time %>
    <%= form.text_field :time, placeholder: '1 pm',
      class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.label :duration, 'Minimum Duration (minutes)' %>
    <%= form.text_field :duration,
      class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.label :cost_override, 'Cost Override (if different)' %>
    <%= form.number_field :cost_override, step: :any,
      class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.check_box :routines, class: 'entry-count h-10' %>
    <%= form.label :routines, 'Agenda Item for "Routines" (include all dances)?' %>
  </div>

  <% if Event.first&.pro_heats %>
  <div class="my-5">
    <%= form.check_box :pro, class: 'entry-count h-10' %>
    <%= form.label :pro, 'Professionals only?' %>
  </div>
  <% end %>

  <div class="inline">
    <%= form.submit class: "rounded-lg py-3 px-5 bg-blue-600 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
